import { render, staticRenderFns } from "./AddFeeding.vue?vue&type=template&id=95cc9998&"
import script from "./AddFeeding.vue?vue&type=script&lang=js&"
export * from "./AddFeeding.vue?vue&type=script&lang=js&"
import style0 from "./AddFeeding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports